import React from 'react'
import Section from '../Section'
import ProjectUnit from '../ProjectUnit'

import typingGameDemo from '../../assets/images/projects/typingGameDemo.png'
import sgCarparkApp from '../../assets/images/projects/sgCarparkApp.png'
import ticSoundDemo from '../../assets/images/projects/ticSoundDemo.png'

class ProjectsSection extends React.Component {
  render() {
    return (
      <Section title="Projects">
      <div className="row">
        <ProjectUnit
          logo={typingGameDemo}
          colour="#FFC0CB"
          title="Typing Game"
          link="https://abdulhakimsg.github.io/Typing-Game/"
          timeperiod="Sept 2018"
          subtitle="A typing game built purely from vanillaJS"
          githubLink="https://github.com/Abdulhakimsg/Typing-Game"
        />
        <ProjectUnit
          logo={sgCarparkApp}
          colour="#DFB94C"
          title="Carpark Finder"
          link="https://sgcarpark-finder.herokuapp.com/"
          timeperiod="October 2018"
          subtitle="Carpark Finder app that leverages on LTA's Datamall API which is updated every minute. 
          Built using NodeJS , express and react-views."
          githubLink="https://github.com/Abdulhakimsg/sgcarpark_avail"
        />
        <ProjectUnit
          logo={ticSoundDemo}
          colour="#000000"
          title="TicSound"
          link="http://ticsound.herokuapp.com/"
          timeperiod="October 2018"
          subtitle="Events Listing site.Built using Ruby on Rails, PostgreSQL and leverages on Google Maps API"
          githubLink = "https://github.com/Abdulhakimsg/ticsound"
        />
      </div>
    </Section>
  )
}
}

export default ProjectsSection



// WEBPACK FOOTER //
// ./src/components/ProjectsSection/index.js